/**
 * The words an admin should read when an API call fails.
 *
 * Our API answers errors as RFC 9457 Problem Details (`title`, `detail`, `code`;
 * backend/src/utils/api-helpers.ts) and never sends `message`. AWS WAF and API
 * Gateway answer `{"message": "..."}`. Until 2026-10-06 adminFetch and the data
 * provider read only `message`, so every refusal from our own API reached the
 * admin as a bare "HTTP 400" (#3350). Prefer `detail` (the specific reason), then
 * `title`, then `message`; with none, say the status.
 */
export function apiErrorMessage(body: unknown, status: number): string {
  if (body && typeof body === 'object') {
    const b = body as { detail?: unknown; title?: unknown; message?: unknown };
    for (const v of [b.detail, b.title, b.message]) {
      if (typeof v === 'string' && v.trim() !== '') return v;
    }
  }
  return `HTTP ${status}`;
}
